import { createFileRoute } from "@tanstack/react-router";
import { POSTS } from "../content/posts";
import { PostCard } from "../components/PostCard";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "The Acadly Archive — Every Note, In Order" },
      {
        name: "description",
        content:
          "Every Acadly piece — subject explainers, exam strategy, study systems, college life and careers, sorted newest first.",
      },
      {
        name: "robots",
        content: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
      },
      { property: "og:site_name", content: "Acadly" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "The Acadly Archive — Every Note, In Order" },
      {
        property: "og:description",
        content: "Every Acadly piece — subject explainers, exam strategy, study systems, college life and careers, sorted newest first.",
      },
      { property: "og:url", content: "https://acadly.in/blog" },
      { property: "og:image", content: "https://acadly.in/og-default.png" },
      { property: "og:image:alt", content: "The Acadly Archive" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "The Acadly Archive — Every Note, In Order" },
      {
        name: "twitter:description",
        content: "Every Acadly piece — subject explainers, exam strategy, study systems, college life and careers, sorted newest first.",
      },
      { name: "twitter:image", content: "https://acadly.in/og-default.png" },
      { name: "twitter:image:alt", content: "The Acadly Archive" },
    ],
    links: [{ rel: "canonical", href: "https://acadly.in/blog" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "The Acadly Archive",
          description: "Every Acadly piece — subject explainers, exam strategy, study systems, college life and careers, sorted newest first.",
          url: "https://acadly.in/blog",
          isPartOf: {
            "@type": "WebSite",
            name: "Acadly",
            url: "https://acadly.in/",
          },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://acadly.in/" },
            { "@type": "ListItem", position: 2, name: "Blog", item: "https://acadly.in/blog" },
          ],
        }),
      },
    ],
  }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <div className="mx-auto max-w-6xl px-5 py-16 md:py-20">
      <header className="mb-14">
        <div className="stamp mb-6">The Archive</div>
        <h1
          className="text-5xl md:text-6xl leading-[1] tracking-tight font-semibold"
          style={{ fontFamily: "var(--font-display)" }}
        >
          Every note, in order.
        </h1>
        <p className="mt-5 max-w-2xl text-lg text-pencil leading-relaxed">
          {POSTS.length} pieces so far. New ones land in the running notebook
          most weeks during term time.
        </p>
      </header>

      <div className="grid gap-10 md:grid-cols-2">
        {POSTS.map((p, i) => (
          <PostCard key={p.meta.slug} meta={p.meta} priority={i < 4} />
        ))}
      </div>
    </div>
  );
}